import React, { useEffect, useState } from "react";
import CardGif from '../../components/Arthmate/Modules/BasicInfo/Cards 2.gif';
import Quick from '../../components/Arthmate/Modules/BasicInfo/quick.svg';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import axios from "axios";
import { env } from "../../environment/environment";

const NoCostBanner = ({ setcrediCardemi, userId }) => {
  const [treatmentAmount, setTreatmentAmount] = useState(0);
  const [doctorId, setDoctorId] = useState('');
  const [loading, setLoading] = useState(true); // ⭐ added

  useEffect(() => {
    const fetchLoanDetails = async () => {
      try {
        const loanResponse = await axios.get(
          `${env.api_Url}userDetails/getLoanDetailsByUserId?userId=${userId}`
        );

        const data = loanResponse?.data?.data;

        if (data) {
          setTreatmentAmount(Number(data.treatmentAmount || 0));
          setDoctorId(data.doctorId || '');
        }

      } catch (error) {
        console.error("Error fetching loan details:", error);
      } finally {
        setLoading(false); // ⭐ API completed
      }
    };

    fetchLoanDetails();
  }, [userId]);

  // ⏳ Wait for API before checking conditions
  if (loading) return null;  // Or show shimmer if needed

  // ⭐ Final rule:
  // - Special doctor → requires amount >= 18000
  // - All other doctors → always show banner
  let showBanner = true;

  if (doctorId === '4fyAO6Ci6vxs5pt7MczXXNowdT3hJCr2') {
    showBanner = treatmentAmount >= 18000;
  }

  if (!showBanner) return null;

  return (
    <div
      style={{
        background: '#EDFEEF',
        padding: '3px 14px',
        marginTop: '20px',
        borderRadius: '5px',
        cursor: 'pointer'
      }}
      onClick={() => setcrediCardemi(true)}
    >
      <div style={{ display: 'flex', width: '100%', paddingTop: '10px' }}>
        
        <div style={{ width: '15%' }}>
          <img src={CardGif} style={{ width: '32px' }} alt="card" />
        </div>

        <div style={{ width: '80%' }}>
          No cost EMI on <b>credit cards</b>
          <br />
          <img src={Quick} style={{ width: '112px', marginTop: '5px' }} alt="quick" />
        </div>

        <div style={{ width: '5%', marginTop: '11px', color: '#45934a' }}>
          <DoubleArrowIcon />
        </div>

      </div>
    </div>
  );
};

export default NoCostBanner;
